import { render, staticRenderFns } from "./BidLink.vue?vue&type=template&id=769c8b36&scoped=true"
import script from "./BidLink.vue?vue&type=script&lang=js"
export * from "./BidLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "769c8b36",
  null
  
)

export default component.exports